import amplitude from "amplitude-js";

class AmplitudeService {
  #instance;
  #isEnabled;
  logEvent; 
  setUserId; 
  setUserProperties;
  
  constructor(isEnabled:any, amplitudeApiKey:any) {
    this.#isEnabled = isEnabled;
    this.#instance = amplitude.getInstance();
    this.#instance.init(amplitudeApiKey);

    this.logEvent = this.environmentBasedExecution("[Amplitude LogEvent]", this.#instance.logEvent);
    this.setUserId = this.environmentBasedExecution("[Amplitude setUserId]", this.#instance.setUserId);
    this.setUserProperties = this.environmentBasedExecution(
      "[Amplitude setUserProperties]",
      this.#instance.setUserProperties,
    );
  }

  environmentBasedExecution(logMessage:any, method:any) {
    return (...args:any) => {
      if (this.#isEnabled) {
        try {
          method.call(this.#instance, ...args);
        } catch (error) {
          console.error("Error executing Amplitude method:", error);
        }
      } else {
        console.log(logMessage, ...args);
      }
    };
  }

  updateUserData(userDetails:any) {
    this.setUserId(userDetails?.id);
    this.setUserProperties({
      entityId: userDetails?.email,
    });
  }
}

const amplitudeInstance = new AmplitudeService(
  window.$nvsConfig.ENABLE_AMPLITUDE === true,
  window.$nvsConfig.AMPLITUDE_API_KEY,
);
// const amplitudeInstance = new AmplitudeService(true,'d01a28c6248c00a35616a4bac2476390');
export default amplitudeInstance;
